<template>
  <div class="card">
    <div class="card-header">
      <h4 class="mb-0">
        {{ $t('requestCountDown.mzakirlr') }}
      </h4>
    </div>
    <div class="card-body">
      <div v-if="conversations.length>0">
        <div
          v-for="c in conversations"
          :key="c.id"
          style="cursor: pointer"
          @click.prevent="$router.push(`/dashboard/conversation/${c.id}`)"
        >
          <div class="d-flex justify-content-between align-items-center my-2">
            <div class="d-flex align-items-center">
              <div class="mr-2">
                <img
                  :src="getPhoto(c.user.photo,'mediumCropped')"
                  class="img-thumbnail rounded-circle"
                  style="height: 50px;"
                  :alt="$t('request.userAvatar')"
                >
              </div>
              <div>
                <span class="text-dark">
                  {{ c.user.name }}  {{ c.user.surname }}
                </span> <br>
                <span class="text-primary ">{{ c.company.name }} {{ getCompanyFormat(c.company.format) }}</span>
              </div>
            </div>

            <div>
              <span
                class="btn btn-primary"
                style="margin-right: 20px"
              >
                {{ $t('mzakirniDavamEt') }}
              </span>
              <span
                v-if="c.open"
                class="badge badge-success"
              >{{ $t('request.aktiv') }}</span>
              <span
                v-else
                class="badge badge-danger"
              >{{ $t('request.tamamlanm') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";

export default {
  name: 'RequestConversations',
  props: {
    conversations: {},
    request: {},
  },

  methods: {

    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
